import {defineStore} from "pinia";

export const useAuthStore = defineStore("authStore", () => {
  const user = {
    avatar: "",
  };

  return {user};
});
